// components
import Notes from 'components/employee-portal/notes/Notes';

// styles
import {
  StyledNotesContainerBox,
  WavyTopBar
} from '../NewFlexRequestDrawer.styles';

// types
import { NotesTypeEnums } from 'components/employee-portal/notes/Notes.types';
import { NotesSectionProps } from './NotesSection.types';
import { DutyLineNote } from 'RestAPIs/employees/hours-table/types';

export const NotesSection = ({
  draftNotes,
  setDraftNotes
}: NotesSectionProps) => {
  const handleAddDraftNote = (note: DutyLineNote) =>
    setDraftNotes((prev) => [...prev, note]);

  const handleRemoveDraftNote = (id: number) =>
    setDraftNotes((prev) => prev.filter((note) => note.id !== id));

  return (
    <StyledNotesContainerBox component="section">
      <WavyTopBar waveSize={32} />
      <Notes
        type={NotesTypeEnums.DUTY_LINE}
        noteData={draftNotes}
        isSavedByParent
        onAddNote={handleAddDraftNote}
        onRemoveNote={handleRemoveDraftNote}
        noteVariant="alternative"
      />
    </StyledNotesContainerBox>
  );
};
